export const METADATA_ROUTE = "/catalogo-metadados";
export const DETAIL_METADATA_ROUTE = (pk: string) => `${METADATA_ROUTE}/${pk}`;
export const CATEGORY_METADATA_ROUTE = (pk: string) =>
  `${METADATA_ROUTE}/categoria/${pk}`;
